import { ProductInterface } from '@vendasta/billing';

export interface Product {
  name: string;
  sku: string;
  iconUrl: string;
  hasPricingOverride: boolean;
  hasDiscount: boolean;
}

export function productFromApi(apiProduct: ProductInterface): Product {
  return {
    name: apiProduct.name || '',
    sku: apiProduct.sku || '',
    iconUrl: apiProduct.iconUrl || '',
    hasPricingOverride: apiProduct.hasPricingOverride || false,
    hasDiscount: apiProduct.hasDiscount || false,
  };
}
